import { useState, type FormEvent } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface PasswordGateProps {
  onSuccess: (email: string) => void;
}

export function PasswordGate({ onSuccess }: PasswordGateProps) {
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const res = await fetch("/api/auth/verify", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ password, email }),
      });

      const data = (await res.json()) as { email?: string; error?: string };

      if (!res.ok) {
        throw new Error(data.error || "Authentication failed");
      }

      if (data.email) {
        onSuccess(data.email);
      } else {
        throw new Error("Authentication failed");
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : "Authentication failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="password-gate-container">
      <div className="planner-box">
        <h1 className="planner-title">🌟 Welcome to the Gathering Planner! 🌟</h1>
        <p className="planner-text">
          Modify and add whatever welcome details you want here
        </p>

        <form onSubmit={handleSubmit} className="planner-form">
          <div className="form-group">
            <Label htmlFor="email" className="planner-label">
              Your Email (Required):
            </Label>
            <Input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="planner-input"
              placeholder="you@example.com"
            />
          </div>

          <div className="form-group">
            <Label htmlFor="password" className="planner-label">
              Event Password:
            </Label>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="planner-input"
              placeholder="Enter password"
            />
          </div>

          {error && <div className="planner-error">⚠️ {error}</div>}

          <Button
            type="submit"
            disabled={loading}
            className="planner-button"
          >
            {loading ? "Checking..." : "Enter Site →"}
          </Button>
        </form>
      </div>
    </div>
  );
}

